import { FC, useEffect, useRef, useState } from 'react';

import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';

export const MultipleChoiceList: FC<{
  options: { label: string; description?: string; value: string; isDisabled?: boolean }[];
  selected?: string[];
  defaultSelected?: string[];
  onChange: (value: string[]) => void;
  isMultiSelect?: boolean;
}> = ({ options, selected: controlledSelected, defaultSelected, onChange, isMultiSelect }) => {
  const isControlledRef = useRef<boolean>(!!controlledSelected);
  const [selectionRecord, setSelectionRecord] = useState<Record<string, boolean>>(
    Object.fromEntries(defaultSelected?.map((value) => [value, true]) ?? []),
  );

  useEffect(() => {
    if (isControlledRef && !!controlledSelected) {
      setSelectionRecord(
        Object.fromEntries(controlledSelected.map((value) => [value, true]) ?? []),
      );
    }
  }, [controlledSelected]);

  const handleSelectAction = (key: string) => {
    const updatedSelectionRecord = isMultiSelect
      ? { ...selectionRecord, [key]: !selectionRecord[key] }
      : { [key]: true };

    setSelectionRecord(updatedSelectionRecord);
    onChange(
      Object.entries(updatedSelectionRecord)
        .filter(([_, selected]) => selected)
        .map(([value]) => value),
    );
  };

  return (
    <div className="d-flex flex-column gap-1">
      {options.map((option, i) => (
        <div
          key={`${option.value}-${i}`}
          className="d-flex gap-2 align-items-center py-1 px-2"
          style={{
            backgroundColor: 'rgba(255,255,255,.1)',
            borderRadius: 8,
            opacity: option.isDisabled ? 0.5 : 1,
          }}
          onClick={() => (option.isDisabled ? null : handleSelectAction(option.value))}
        >
          <div style={{ fontSize: '1.1rem' }}>
            {selectionRecord[option.value] ? (
              <span style={{ color: 'var(--color-green)' }}>
                <FontAwesomeIcon name="check-circle" />
              </span>
            ) : (
              <FontAwesomeIcon faStyle="far" name="circle" />
            )}
          </div>
          <div className="d-grid">
            <strong>{option.label}</strong>
            {option.description && <span style={{ fontSize: '.8rem' }}>{option.description}</span>}
          </div>
        </div>
      ))}
    </div>
  );
};
